<template>
    <div>
        <div class="header">
            <div>
                <img src="C:\Users\AB TRADERS\Policy\CSI LOGO.png" alt="CSI Logo">
            </div>
            <div class="contact-info">
                <h1>Crescent Star Insurance Ltd.</h1>
                <p>2nd Floor, Nadir House, I.I. Chundrigar Road, Karachi - 74000, Pakistan</p>
                <p>T: (92-21) 32415471-3 F: (92-21) 32415474 E: info@cstarinsurance.com W: www.cstarinsurance.com</p>
            </div>
            <div>
                <img src="C:\Users\AB TRADERS\Policy\CSI QR.png" alt="QR Code">
            </div>
        </div>
        <hr width="100%" size="2" color="black">
        <div class="title">MOTOR VEHICLE THIRD PARTY RISK INSURANCE POLICY</div>
        <div class="subtitle">FOR COMMERCIAL VEHICLE ONLY<br>(Schedule)</div>
        <hr width="100%" size="2" color="black">
        <table>
            <tr>
                <th style="width:20%">Policy No.</th>
                <td style="width:30%">{{ item.PolicyNo }}</td>
                <th style="width:20%">Branch</th>
                <td style="width:30%">{{ item.BranchName }}</td>
            </tr>
            <tr>
                <th>Business Class</th>
                <td>{{ item.BusinessClass }}</td>
                <th>Issue Date</th>
                <td>{{ item.IssueDate }}</td>
            </tr>
            <tr>
                <th>Producer</th>
                <td>{{ item.ProducerCode }}</td>
                <th>Old Ref No.</th>
                <td>{{ item.OldRefNo }}</td>
            </tr>
            <tr>
                <th>Agency</th>
                <td>{{ item.AgencyCode }}</td>
                <th>NIC No.</th>
                <td>{{ item.ClientNic }}</td>
            </tr>
            <tr>
                <th>Client Code</th>
                <td>{{ item.ClientCode }}</td>
                <th>Mobile No.</th>
                <td>{{ item.ClientNo }}</td>
            </tr>
            <tr>
                <th>The Insured</th>
                <td>{{ item.Insured }}</td>
                <td colspan="2"></td>
            </tr>
            <tr>
                <th>Address</th>
                <td colspan="3">{{ item.Address }}</td>
            </tr>
            <tr>
                <th>Period of Insurance</th>
                <td colspan="3">
                    a) {{ item.PeriodFrom }} To {{ item.PeriodTo }} (Both dates inclusive) (365 days)<br>
                    b) Any subsequent period for which the Insured shall pay and Company shall agree to accept a renewal premium.
                </td>
            </tr>
            <tr>
                <th>Geographical Area</th>
                <td colspan="3">{{ item.GeographicalAreaID }}</td>
            </tr>
        </table>
        <hr width="100%" size="2" color="black">
        <table>
            <tr>
                <th style="width:20%">Registration No.</th>
                <td style="width:30%">{{ item.VehicleRegistrationNo }}</td>
                <th style="width:20%">Type of Body</th>
                <td style="width:30%">{{ item.TypeOfBody }}</td>
            </tr>
            <tr>
                <th>Engine No.</th>
                <td>{{ item.EngineNo }}</td>
                <th>Cubic Capacity</th>
                <td>{{ item.CubicCapacity }}</td>
            </tr>
            <tr>
                <th>Chassis No.</th>
                <td>{{ item.ChassisNo }}</td>
                <th>Year of Manufacture</th>
                <td>{{ item.YearOfManufacture }}</td>
            </tr>
            <tr>
                <th>Make</th>
                <td>{{ item.Make }}</td>
                <th>Sub Make</th>
                <td>{{ item.SubMake }}</td>
            </tr>
            <tr>
                <th>Color</th>
                <td>{{ item.Color }}</td>
                <th>Seating Capacity</th>
                <td>{{ item.SeatingCapacity }}</td>
            </tr>
            <tr>
                <th>Limit of Liability</th>
                <td>{{ item.LimitOfLiability }}</td>
                <th>Keeper Emp No.</th>
                <td>{{ item.Keeper }}</td>
            </tr>
        </table>
        <hr width="100%" size="2" color="black">
        <div class="description">
            <div class="description-heading">Description</div>
            {{ item.Description }}
        </div>
        <hr width="100%" size="2" color="black">
        <table>
            <tr>
                <th style="width:20%">Limit of Liability</th>
                <td style="width:30%">{{ item.LiabilityLimit }}</td>
                <th style="width:20%">Premium</th>
                <td style="width:30%">Rs. 600.00</td>
            </tr>
        </table>
        <hr width="100%" size="2" color="black"><br>
        <div class="closing">
            Subject to the clauses, endorsements & warranty attached.<br><br>
            <div class="under"> "For policy verification, please visit our website at: verify.csi.com.pk"</div>
        </div><br>

        <div class="footer">
            "This is a system-generated document and does not require a signature."
        </div>
    </div>
</template>
<script>
  import axios from 'axios'
  export default {
    data() {
          return {
              item: {},   
          }
    },
    created() {
      this.pageload();
    },
    methods: {
        pageload() {
            var vm = this;
            const url = new URLSearchParams(window.location.search);
            const id = url.get("id");
            axios.get('/api/IMSApi/PolicyPrint?ID=' + id)
                .then((res) => {
                    if (res.data.status) {
                        vm.item = res.data.PolicyPrint;
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
    },
  };
</script>
<style>
    body {
        font-family: Arial, sans-serif;
        line-height: 1.6;
    }

    .header {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

        .header img {
            width: 70px;
        }

        .header .contact-info {
            text-align: center;
            font-size: 10px;
        }

    .title {
        text-align: center;
        font-size: 12px;
        font-weight: bold;
        margin: 10px 0;
    }

    .subtitle {
        text-align: center;
        font-size: 10px;
        font-weight: bold;
    }

    table {
        width: 100%;
    }

    th, td {
        text-align: left;
        font-size: 10px;
    }

    th {
        font-weight: bold;
    }

    .description, .footer {
        font-size: 10px;
        text-align: left;
    }

        .description .description-heading {
            text-align: center;
            font-weight: bold;
        }

    .closing {
        text-align: center;
        font-size: 10px;
    }

        .closing .under {
            text-align: center;
            font-size: 10px;
            text-decoration: underline;
            font-weight: bold;
            font-style: italic;
        }

    .footer {
        font-size: 10px;
        text-align: center;
        font-style: italic;
        font-weight: bold;
        font-size: medium;
    }
</style>


// WEBPACK FOOTER //
// src/components/ims/PolicyPrint.vue